import i18n from "i18next";
import { initReactI18next } from "react-i18next";

import { TRANSLATION_RESOURCES } from "./locales";

i18n
    .use(initReactI18next)
    .init({
        debug: true,
        fallbackLng: "en",
        interpolation: {
            escapeValue: false,
        },
        resources: TRANSLATION_RESOURCES,
    });

export default i18n;
